<template>
  <div>
    <vx-card :title="$t('filters')" class="mb-8" style="background: white">
      <template slot="actions">
        <feather-icon icon="FilterIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="filter"/>
        <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="resetFilter"/>
      </template>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="p-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75">{{$t('client')}}</label>
            </vs-col>
            <vs-col>
              <v-select :placeholder="$t('client')" multiple v-model="params.client_id" :options="clients" label="ShortName" :reduce="(client) => client.ClientId" class="w-full" />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="p-2">
          <vs-row>
            <vs-col>
              <label class="text-sm opacity-75">{{ $t('vendor') }}</label>
            </vs-col>
            <vs-col>
              <v-select multiple :placeholder="$t('vendor')" v-model="params.vendor_id" :options="vendors" label="VendorName" :reduce="(vendor) => vendor.VendorId" class="w-full" />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-card>
      <div id="blacklist-table-loading" class="vs-con-loading__container">
        <vs-row vs-type="flex" vs-justify="flex-end" class="mb-4">
          <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="p-2">
            <vs-input icon-pack="feather" icon="icon-search" :placeholder="$t('search')" v-model="params.search" class="w-full" @keyup.enter="search"/>
          </vs-col>
          <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="p-2">
            <export-button :data="this.params" :url="'blacklist/export/OSJR_xjuSmuXjums2q8S_26_au8282'"/>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <blacklist-table :data="blacklist" @loadMore="loadMore" @sort="handleClickSort"/>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>
<script>
import blacklist from '@/http/requests/blacklist'
import client from '@/http/requests/client'
import vSelect from 'vue-select'
import moduleBlacklist from '@/store/blacklist/moduleBlacklist.js' 
import BlacklistTable from './BlacklistTable.vue'
import loading from '@/mixins/Loading.js'
import ExportButton from '@/views/components/ExportButton.vue'

export default {
  mixins: [loading],
  components: {
    'v-select': vSelect,
    ExportButton,
    BlacklistTable
  },
  data: () => ({
    clients: [],
    vendors: [{ id: 1, vendor_name: 'vendor_name' }],
    lastPage:1,
    params: {
      client_id: null,
      vendor_id: null,
      groupBy:['Vendors.appears_since','Vendors.VendorName','Vendors.VendorId','Vendors.RFC','cl.ClientName'],
      sort:['DESC'],
      sortBy:['Vendors.appears_since']
    }
  }),
  computed: {
    blacklist() {
      return this.$store.state.blacklist.blacklist
    }
  },
  created() {
    if (!moduleBlacklist.isRegistered) {
      this.$store.registerModule('blacklist', moduleBlacklist)
      moduleBlacklist.isRegistered = true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      this.getVendors()
      this.getClients()
      this.search()
    },
    search(){
      this.params.page = 1
      this.getBlacklist()
        .then(res => { this.closeLoading('blacklist-table-loading') })
        .catch(err => { this.closeLoading('blacklist-table-loading') })
    },
    filter() {
      this.search()
    },
    resetFilter() {
      this.params={
      client_id: null,
      vendor_id: null,
      groupBy:['Vendors.appears_since','Vendors.VendorName','Vendors.VendorId','Vendors.RFC','cl.ClientName']
      }
      this.sortParams={
        sort:'DESC',
        sortBy:'Vendors.appears_since'
      }
      this.search()
    },
    getBlacklist() {
      this.openLoading('blacklist-table-loading')
      return this.$store.dispatch('blacklist/fetchBlacklist', this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.search()
    },
    getClients() {
      client.list().then(res=>{
        this.clients=res.data.clients
      })
    },
    getVendors() {
      blacklist.assignedVendors().then(res=>{
        this.vendors=res.data.vendors
      })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getBlacklist()
        .then(res => { this.closeLoading('blacklist-table-loading') })
        .catch(err => { this.closeLoading('blacklist-table-loading') })
    }
  }
}

</script>
<style lang="css" scoped>
</style>
